import { Flex, Grid, Text } from '@chakra-ui/react'
import React from 'react'
import ChartWrapper from '~/pages/Dashboards/CallReporting/Shared/ChartWrapper'
import { textStyleKeys } from '~/themes/textStyles'

import { CallsReport, CallsReportData } from '@mangovoice/types'

import BigCounter from './BigCounter'

export interface StatsMetric {
  label: string
  compute: (data: CallsReportData[]) => number
  isPercentage?: boolean
}

interface StatsGridProps {
  data: CallsReport
  metrics: StatsMetric[]
  title?: string
  columns?: number
}

const StatsGrid = ({
  data,
  metrics,
  title = 'Statistics',
  columns,
}: StatsGridProps) => {
  if (!data || !data.data || data.data.length === 0)
    return <Text>No statistics available</Text>

  const reportData = data.data

  let defaultColumns: number
  if (metrics.length === 3 || metrics.length === 4) {
    defaultColumns = 2
  } else if (metrics.length === 1) {
    defaultColumns = 1
  } else {
    defaultColumns = metrics.length
  }
  const gridColumns = columns || defaultColumns

  return (
    <ChartWrapper height="100%" display="flex" flexDirection="column">
      <Flex alignItems="center" justifyContent="space-between" mb="1rem">
        <Flex textStyle={textStyleKeys.Body2_Bold} color="gray.1300">
          {title}
        </Flex>
      </Flex>

      <Flex flex="1" align="center" justify="center">
        <Grid
          templateColumns={{
            base: `repeat(${gridColumns}, 1fr)`,
            xs: `repeat(1, 1fr)`,
          }}
          gap={8}
          width="100%"
        >
          {metrics.map((metric, index) => {
            const value = metric.compute(reportData)
            const commonFlexProps = {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }
            const gridItemProps =
              metrics.length === 3 && index === 2
                ? { gridColumn: '1 / -1', ...commonFlexProps }
                : commonFlexProps

            return (
              <Flex key={index} {...gridItemProps}>
                <BigCounter
                  value={value}
                  label={metric.label}
                  isPercentage={metric.isPercentage}
                />
              </Flex>
            )
          })}
        </Grid>
      </Flex>
    </ChartWrapper>
  )
}

export default StatsGrid
